export { default as RatingView } from './rating-view';
export type { RatingViewProps } from './types';
